import { wantsSurfGame } from './detect.js';

/**
 * Immediate "tuning" panel. Painted before the game chunk arrives so a
 * handheld tap never lands on an empty black frame.
 * @param {HTMLElement} host
 * @returns {HTMLElement|null}
 */
export function mountChannelBoot(host) {
  if (!host) return null;
  const existing = host.querySelector(':scope > .channel-boot');
  if (existing) return existing;

  const surf = wantsSurfGame();
  const el = document.createElement('div');
  el.className = 'channel-boot';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-live', 'polite');
  el.setAttribute('aria-label', surf ? 'Loading Channel Surfing' : 'Loading Captain Mild Concern');
  el.innerHTML = `
    <p class="channel-boot__kicker">${surf ? 'CHANNEL SURFING' : 'CAPTAIN MILD CONCERN'}</p>
    <p class="channel-boot__line">TUNING THE SET</p>
    <div class="channel-boot__bar" aria-hidden="true"><span></span></div>
  `;
  host.appendChild(el);
  return el;
}
